import type { ButtonProps } from "@mui/material";

export enum SizesEnum {
	AUTO = "auto",
	XS = "xsmall",
	UNDER_SM = "under-small",
	SM = "small",
	UNDER_MD = "under-medium",
	MD = "medium",
	LG = "large",
	XL = "xlarge",
	XXL = "xxlarge"
}

// Button component types
export enum ButtonSizesEnum {
	// AUTO = "auto",
	// XS = "xsmall",
	// UNDER_SM = "under-small",
	// UNDER_MD = "under-medium",
	XXXS = "xxxsmall",
	XXS = "xxsmall",
	XS = "xsmall",
	SM = "small",
	MD = "medium",
	LG = "large",
	XL = "xlarge"
	// XXL = "xxlarge"
}

// Button component types
export enum InputSizesEnum {
	MD = "medium",
	LG = "large"
}

export enum ButtonVariantsEnum {
	GREEN = "green",
	RED = "red",
	LIGHT_GREY = "light_grey",
	DARK_GREY = "dark_grey",
	DARK = "dark",
	GREEN_OUTLINED = "green_outlined",
	WHITE_OUTLINED = "white_outlined",
	WHITE_BORDERED = "white_bordered",
	RED_OUTLINED = "red_outlined"
}

export interface ButtonsPropsBase {
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	variant?: ButtonVariantsEnum;
	ref?: ButtonProps["ref"];
	disabled?: boolean;
}

// Text component types
export enum TextVariantsEnum {
	H1 = "H1",
	H2 = "H2",
	H3 = "H3",
	H4 = "H4",
	H5 = "H5",
	H6 = "H6",
	H7 = "H7",
	H8 = "H8",
	Body2XLarge = "Body2XLarge",
	BodyXLarge = "BodyXLarge",
	BodyLarge = "BodyLarge",
	BodyMedium = "BodyMedium",
	BodySmall = "BodySmall",
	BodyXSmall = "BodyXSmall",
	Caption = "Caption",
	Caption2 = "Caption2",
	Caption3 = "Caption3",
	Caption4 = "Caption4",
	Caption5 = "Caption5",
	SPAN = "SPAN",
	INHERIT_SPAN = "INHERIT_SPAN",
	Numbers14 = "Numbers14"
}

export enum MenuListPositionOpts {
	TOP_LEFT = "top-left",
	TOP_CENTER = "top-center",
	TOP_RIGHT = "top-right",
	CENTER_LEFT = "center-left",
	CENTER_CENTER = "center-center",
	CENTER_RIGHT = "center-right",
	BOTTOM_LEFT = "bottom-left",
	BOTTOM_CENTER = "bottom-center",
	BOTTOM_RIGHT = "bottom-right"
}

export enum UploaderSizesEnum {
	Small96 = "Small96",
	Small240 = "Small240",
	Rectangle420 = "Rectangle420"
}

export enum ErrorMessageTypes {
	DEFAULT = "DEFAULT",
	WARNING = "WARNING",
	HINT = "HINT"
}
